import styled from 'styled-components';
import { COLOR_WHITE, COLOR_ORANGE } from '../../assets/styles/colors';
import { rgba } from 'polished';
import { BP_TABLET_MAX } from '../../assets/styles/breakpoints';

export default styled.table`
  width: 100%;
  thead {
    border-collapse: separate;
    tr {
      th {
        position: relative;
        font-weight: normal;
        text-align: center;
        padding-bottom: 8px;
        padding-top: 6px;

        &:before {
          z-index: 0;
          position: absolute;
          top: 0px;
          left: 0px;
          content: '';
          width: 100%;
          height: 100%;
          border: 2px solid white;
          border-right: none;
          border-left: none;
        }

        &:first-child {
          text-align: left;
          padding-left: 32px;

          &:before {
            border-top-left-radius: 20px;
            border-left: 2px solid white;
          }
        }
        &:last-child {
          padding-right: 32px;
          &:before {
            border-top-right-radius: 20px;
            border-right: 2px solid white;
          }
        }
      }
    }
  }
  tbody {
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;

    td {
      &:first-child {
        text-align: left;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    tbody {
      box-shadow: none;
      border-radius: 0px;
    }
  }
`;

export const AdditionalTopSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .line-separator {
    width: calc(100% - 170px);
    height: 1px;
    background: #eaeaec;
  }
`;

export const PaginationWrapSC = styled.div`
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  height: 50px;
  padding: 0 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  .arrow-wrap {
    padding-left: 16px;
    align-items: center;
    display: flex;
  }

  button {
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${rgba(COLOR_ORANGE, 0.2)};
    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      margin-right: 1px;
    }
    &:last-child {
      margin-left: 1px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    padding: 0 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`;

export const EmptySC = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: ${({ full }) => (full ? 'calc(100vh - 400px)' : '100px')};
`;
